import { Http } from '@intelipost-js/secure-providers';

export default {
  getInvoices(context) {
    context.commit('toggleLoading', true);

    return Http.get('/audit/v1/invoices/result/most_recent')
      .then((res) => {
        context.commit('setInvoices', res.data);
        context.commit('toggleLoading', false);
      })
      .catch(() => context.commit('toggleLoading', false));
  },
  download({ commit }, url) {
    commit('toggleLoading', true);

    return Http.get(url)
      .then((res) => {
        commit('toggleLoading', false);
        window.open(res.data.url, '_black');

        return Promise.resolve(res);
      })
      .catch(() => commit('toggleLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/files/invoices/store/actions.js